import React from "react";
import { Vehicule } from "../interfaces";
import { FuelCard } from "../interfaces/FuelCard.interface";

const AlertContext = React.createContext<{
  alertCarteCarbu: boolean;
  setAlertCarteCarbu: React.Dispatch<React.SetStateAction<boolean>>;
  numberAlertCarteCarbu: FuelCard[];
  setNumberAlertCarteCarbu: React.Dispatch<React.SetStateAction<FuelCard[]>>;
  alertVehCT: boolean;
  setAlertVehCT: React.Dispatch<React.SetStateAction<boolean>>;
  numberAlertVehCT: Vehicule[];
  setNumberAlertVehCT: React.Dispatch<React.SetStateAction<Vehicule[]>>;
  alertVehAss: boolean;
  setAlertVehAss: React.Dispatch<React.SetStateAction<boolean>>;
  numberAlertVehAss: Vehicule[];
  setNumberAlertVehAss: React.Dispatch<React.SetStateAction<Vehicule[]>>;
}>({
  alertCarteCarbu: false,
  setAlertCarteCarbu: () => {},
  numberAlertCarteCarbu: [],
  setNumberAlertCarteCarbu: () => {},
  alertVehCT: false,
  setAlertVehCT: () => {},
  numberAlertVehCT: [],
  setNumberAlertVehCT: () => {},
  alertVehAss: false,
  setAlertVehAss: () => {},
  numberAlertVehAss: [],
  setNumberAlertVehAss: () => {},
});

export default AlertContext;
